'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name heroCarousel
    * @description initializes hero carousel slider
    **/

    var initialize = function () {

        let $sliders = $('.hero-slider');
        let isSlider = $sliders.flexslider && $('.hero-slider li').length > 1;

        //Wrap slider controls
        $('#slider ul:first-child').addClass('slide-list');
        $('#slider').children().not('.slide-list').wrapAll('<div class="control-container"><div class="slider-nav-overlay"></div></div>');

        if (!isSlider) {
            $('#slider .control-container').css('display', 'none');
            return;
        }

        jQuery.each($sliders, function (si, el) {
            var $slider = $(el);
            var slideshowSpeed = $slider.attr('data-slide-speed');
            $slider.flexslider({
                namespace: "",
                animation: "fade",
                selector: "ul > li",
                slideshowSpeed: slideshowSpeed,
                animationSpeed: "1000",
                controlNav: true,
                directionNav: true,
                controlsContainer: '#' + $slider.attr('id') + ' .controls-wrapper',
                prevText: "",
                nextText: "",
                pauseOnAction: true
            });

            var $controlNav = $slider.find('.control-nav li a');
            var $playButton = $slider.find('.play-controls .play-button');
            var $pauseButton = $slider.find('.play-controls .pause-button');
            var $controls = $slider.find('.control-nav li a, .direction-nav li a');
            $playButton.on('click', function (e) {
                e.preventDefault();
                $slider.flexslider('play');
                $playButton.css('display', 'none');
                $pauseButton.css('display', 'block');
            });
            $pauseButton.on('click', function (e) {
                e.preventDefault();
                $slider.flexslider('pause');
                $pauseButton.css('display', 'none');
                $playButton.css('display', 'block');
            });
            $controls.on('click', function (e) {
                $pauseButton.css('display', 'none');
                $playButton.css('display', 'block');
            });
            var $slideInfoTitle = $slider.find('ul li .slide-info h1');
            var slideInfo = [];
            for (var iti = 0; iti < $slideInfoTitle.length; iti++) {
                slideInfo.push($slideInfoTitle[iti]);
            };
            for (var cni = 0; i < $controlNav.length; i++) {
                var slideName = slideInfo[cni];
                var label = 'Slider ' + (cni + 1) + ' - ' + slideName.textContent;
                $($controlNav[cni]).attr('aria-label', label);
            };
        });

        initializeAdditionalBehavior();
    };

    // I'm not sure this is used anymore, and I don't have time
    // to figure it out and describe it. For now, its here
    function initializeAdditionalBehavior () {
        //Slider Nav Overlay Toggle
        $('#slider ul li').on('hover', function (e) {
            $('.slider-nav-overlay').toggleClass('show');
        });
        $('#slider .control-container').on('hover', function (e) {
            $('.slider-nav-overlay').toggleClass('show');
        });
        $('#slider .control-nav').on('hover', function (e) {
            $('.slider-nav-overlay').toggleClass('show');
        });
        $('#slider .direction-nav').on('hover', function (e) {
            $('.slider-nav-overlay').toggleClass('show');
        });
        $('#slider .direction-nav .nav-prev').on('hover', function (e) {
            $('.slider-nav-overlay').toggleClass('show');
        });
        $('#slider .direction-nav .nav-next').on('hover', function (e) {
            $('.slider-nav-overlay').toggleClass('show');
        });

        //Set height to tallest slider
        var allSlide = $('#slider ul.slide-list li .slide-info');
        var slideList = $('#slider ul.slide-list');
        var slideListItem = $('#slider ul li');
        var sHeight = [];

        function getSliderHeight() {
            for (var i = 0; i < allSlide.length; i++) {
                if ($(allSlide[i]).children().hasClass('contain')) {
                    //
                }
                else {
                    $(allSlide[i]).children().wrapAll('<div class="contain"></div>');
                }
                var allHeights = $(allSlide[i]).find('.contain').height();
                //console.log(allHeights);
                sHeight.push(allHeights);
            };
            var maxValueInArray = Math.max.apply(Math, sHeight);

            for (var i = 0; i < slideListItem.length; i++) {
                $(slideList).css('min-height', (maxValueInArray + 60));
                $(slideListItem[i]).css('min-height', (maxValueInArray + 60));
            };

        }
        getSliderHeight();

        $(window).on('resize', function () {
            getSliderHeight();
        });
    }

    return {
        initialize: initialize
    };
}())